const vehicleType = {
    FOOT: "A pé",
    MOTORCYCLE: "Motocicleta",
    AIRCRAFT: "Aeronave",
    TRUCK: "Caminhão",
    SHIP: "Embarcação",
    BICYCLE: "Bicicleta",
    VAN: "Van",
    UTILITY: "Utilitário",
    STATION_WAGON: "Caminhonete",
    PICKUPB: "Camioneta",
    BUS: "Ônibus",
    MINIBUS: "Micro-ônibus",
    CAR: "Automóvel",
    ELECTRICCAR: "Carro Elétrico",
    QUADRICYCLE: "Quadriciclo",
    WINCH: "Guincho",
};

export const translateVehicleType = (type) => {
    return vehicleType[type] || type || "";
};

export const fixMonetaryValue = (value) => {
    if (!value) return value;
    const stringValue = String(value);

    const match = stringValue.match(/^(.+\.\d)$/);

    if (match) return `${stringValue}0`;
    return stringValue;
};

export const readjustTimezone = (dateString, hours = 3) => {
    if (!dateString) return '';

    const [datePart, timePart] = dateString.split(' ');
    if (!datePart || !timePart) return dateString;

    const [day, month, year] = datePart.split('/').map(Number);
    const [hour, minute] = timePart.split(':').map(Number);

    const date = new Date(year, month - 1, day, hour, minute);

    date.setHours(date.getHours() + hours);

    const formattedDay = String(date.getDate()).padStart(2, '0');
    const formattedMonth = String(date.getMonth() + 1).padStart(2, '0');
    const formattedYear = date.getFullYear();

    const formattedHour = String(date.getHours()).padStart(2, '0');
    const formattedMinute = String(date.getMinutes()).padStart(2, '0');

    return `${formattedDay}/${formattedMonth}/${formattedYear} ${formattedHour}:${formattedMinute}`;
};